import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="contact-page">
      <div className="mb-12">
        <p className="label-small text-[#C5A059] mb-3">Sumanya · Talk To Us</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#2C2A29]" data-testid="page-title">
          We&apos;re here to help.
        </h1>
        <p className="text-lg text-[#595552] mt-4 max-w-2xl leading-relaxed">
          Whether you have a question about a product, need help with an order, want to know more
          about an exchange, or simply want to speak with us before making a purchase — our team is happy to help.
        </p>
        <div className="mt-6 h-px w-24 bg-[#C5A059]" />
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-14">
        {/* Get in touch card */}
        <div className="bg-white border border-[#EAE3D9] rounded-2xl p-6" data-testid="contact-getintouch">
          <h2 className="font-display text-2xl text-[#2C2A29] mb-5">Get in touch</h2>
          <div className="space-y-4">
            <a href="tel:+918210981248" className="flex items-start gap-3 group" data-testid="contact-phone">
              <div className="p-2 rounded-xl bg-[#FFF5F3] border border-[#EAE3D9]">
                <Phone className="h-4 w-4 text-[#8B1E28]" />
              </div>
              <div>
                <div className="text-xs text-[#8A8480] label-small">Phone</div>
                <div className="text-[15px] text-[#2C2A29] group-hover:text-[#8B1E28] transition">+91-8210981248</div>
              </div>
            </a>
            <a href="mailto:info@sumanya.co" className="flex items-start gap-3 group" data-testid="contact-email">
              <div className="p-2 rounded-xl bg-[#FFF5F3] border border-[#EAE3D9]">
                <Mail className="h-4 w-4 text-[#8B1E28]" />
              </div>
              <div>
                <div className="text-xs text-[#8A8480] label-small">Email</div>
                <div className="text-[15px] text-[#2C2A29] group-hover:text-[#8B1E28] transition">info@sumanya.co</div>
              </div>
            </a>
            <div className="flex items-start gap-3" data-testid="contact-address">
              <div className="p-2 rounded-xl bg-[#FFF5F3] border border-[#EAE3D9]">
                <MapPin className="h-4 w-4 text-[#8B1E28]" />
              </div>
              <div>
                <div className="text-xs text-[#8A8480] label-small">Address</div>
                <div className="text-[15px] text-[#2C2A29] leading-relaxed">
                  Sumanya · Suman Jewellers<br />
                  Sahebganj, Khanua<br />
                  Chapra, Bihar – 841301<br />
                  India
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Support card */}
        <div className="bg-[#FFF5F3] border border-[#EAE3D9] rounded-2xl p-6" data-testid="contact-support">
          <h2 className="font-display text-2xl text-[#2C2A29] mb-5">Customer support</h2>
          <p className="text-sm text-[#595552] mb-4">For assistance with:</p>
          <ul className="grid grid-cols-1 gap-2 text-[15px] text-[#595552]">
            {[
              "Product information",
              "Online orders",
              "Order tracking",
              "Shipping",
              "Returns & exchanges",
              "Diamond certificates",
              "Jewellery care",
              "Repairs and cleaning",
              "Lifetime exchange",
            ].map((s) => (
              <li key={s} className="flex items-start gap-2">
                <span className="text-[#C5A059] mt-1.5">·</span>
                <span>{s}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Visit store */}
      <div className="bg-white border border-[#EAE3D9] rounded-2xl p-8 text-center" data-testid="contact-visit">
        <h2 className="font-display text-3xl text-[#2C2A29] mb-3">Visit our store</h2>
        <p className="text-[15px] text-[#595552] mb-2">Prefer to see your jewellery in person?</p>
        <p className="text-[15px] text-[#595552] mb-6">You are always welcome to visit our physical showroom.</p>
        <div className="text-[#2C2A29] font-semibold text-lg">Suman Jewellers</div>
        <div className="text-[#8A8480] text-sm mt-1">Sahebganj, Khanua · Chapra, Bihar – 841301</div>
      </div>
    </div>
  );
}
